export default "__VITE_ASSET__e14ce47f__"